import { fmtMoney } from "@/lib/api";

const DIRECCION_LABEL = {
  emitido: "Emitido",
  recibido: "Recibido",
};

/**
 * Lista compacta de CFDI sin XML integrado (fecha, UUID, montos).
 */
export default function XmlPendingDetailsList({ items = [], className = "", showClient = false }) {
  if (!items?.length) return null;
  const withClient = showClient || items.some((row) => row.client_label);

  return (
    <div
      className={`rounded-sm border border-amber-300/80 bg-white/80 overflow-x-auto ${className}`.trim()}
      data-testid="xml-pending-details-list"
    >
      <table className="w-full text-xs">
        <thead className="bg-amber-100/60 text-amber-950">
          <tr>
            <th className="text-left px-3 py-2 font-semibold">Fecha</th>
            {withClient ? (
              <th className="text-left px-3 py-2 font-semibold hidden md:table-cell">Cliente</th>
            ) : null}
            <th className="text-left px-3 py-2 font-semibold">UUID</th>
            <th className="text-left px-3 py-2 font-semibold hidden sm:table-cell">Serie-Folio</th>
            <th className="text-right px-3 py-2 font-semibold">Total</th>
            <th className="text-left px-3 py-2 font-semibold hidden md:table-cell">Tipo</th>
          </tr>
        </thead>
        <tbody>
          {items.map((row) => (
            <tr key={`${row.client_id || ""}-${row.uuid}`} className="border-t border-amber-100">
              <td className="px-3 py-2 tabular-nums whitespace-nowrap">{row.fecha || "—"}</td>
              {withClient ? (
                <td className="px-3 py-2 hidden md:table-cell max-w-[140px] truncate" title={row.client_label}>
                  {row.client_label || "—"}
                </td>
              ) : null}
              <td className="px-3 py-2 font-mono text-[10px] break-all">{row.uuid || "—"}</td>
              <td className="px-3 py-2 hidden sm:table-cell">{row.serie_folio || "—"}</td>
              <td className="px-3 py-2 text-right tabular-nums whitespace-nowrap">
                {row.total != null ? fmtMoney(row.total) : "—"}
              </td>
              <td className="px-3 py-2 hidden md:table-cell whitespace-nowrap">
                {DIRECCION_LABEL[row.direccion] || row.direccion || "—"}
                {row.tipo_comprobante ? ` · ${row.tipo_comprobante}` : ""}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
